import type { Message } from '../state/chatTypes';

/**
 * Finds the newest user turn without requiring Array.findLast support.
 * @param messages - Conversation timeline ordered oldest to newest
 */
export const getLatestUserMessage = (
  messages: ReadonlyArray<Message>
): Message | undefined => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message.role === 'user') {
      return message;
    }
  }
  return undefined;
};
